<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2018-12-29 17:34:06
 * @LastAuthor: xiaoyao
 * @lastTime: 2021-05-17 10:38:58
 -->
<template>
  <div id="app">
    <a-config-provider  :locale="zh_CN">
    <router-view v-if="isRouterAlive"></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enquireScreen from '@/utils/device'
import 'moment/locale/zh-cn';

export default{
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
      return {
          reload: this.reload                                              
      }
  },
  data(){
    return{
      zh_CN,
      isRouterAlive:true    //控制视图是否显示的变量
    }
  },
  created(){
    const _this = this
    enquireScreen(deviceType => {
      // tablet
      if (deviceType === 0) {
        _this.$store.commit('TOGGLE_DEVICE', 'mobile')
        _this.$store.dispatch('setSidebar', false)
      }
      // mobile
      else if (deviceType === 1) {
        _this.$store.commit('TOGGLE_DEVICE', 'mobile')
        _this.$store.dispatch('setSidebar', false)
      }
      else {
        _this.$store.commit('TOGGLE_DEVICE', 'desktop')
        _this.$store.dispatch('setSidebar', true)
      }

    })
  },
  methods:{
    reload () {
        this.isRouterAlive = false;            //先关闭，
        this.$nextTick(function () {
            this.isRouterAlive = true;         //再打开
        }) 
    }
  }
}
  
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
    /*margin-top: 60px;*/
  }
  .focus-operation {
    z-index: 1100;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue